import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import autoTable from "jspdf-autotable";
import '../style/InvoiceGenerator.css';

const InvoiceGenerator = () => {
  const [invoiceData, setInvoiceData] = useState({
    // Company details
    companyName: 'UNITEE STUDIOS PRIVATE LIMITED',
    companyAddress: 'Maharashtra, India',
    gstin: '27AADCU3575G1Z5',
    companyEmail: 'rajprit@uniteeculture.com',
    companyFullAddress: '1ST FLOOR, PLOT 304/E/, 3, WAKHARIA BUILDING Vithalbhai Patel Road\nMUMBAI',
    
    // Invoice details
    invoiceDate: '',
    invoiceNumber: '',
    
    // Bill To details
    billToName: '',
    billToAddress: '',
    billToState: '',
    billToPinCode: '',
    billToGST: '',
    
    // Ship To details
    shipToName: '',
    shipToAddress: '',
    shipToCity: '',
    shipToState: '',
    shipToPinCode: '',
    
    // GST Type (IGST or CGST+SGST)
    gstType: 'igst',
    
    // Items
    items: [
      {
        description: '',
        hsnSac: '',
        qty: 1,
        rate: 0,
        taxPercent: 5,
        igstPercent: 5,
        igstAmount: 0,
        cgstPercent: 2.5,
        cgstAmount: 0,
        sgstPercent: 2.5,
        sgstAmount: 0,
        amount: 0
      }
    ],
    
    // // Shipping
    shippingCharge: 0,
    shippingGST: 18,
    shippingIGST: 18,
    shippingCGST: 9,
    shippingCGSTAmount: 0,
    shippingSGST: 9,
    shippingSGSTAmount: 0,
    shippingIGSTAmount: 0,
    shippingTotal: 0,
    
    // Totals
    taxableValue: 0,
    totalIGST: 0,
    totalCGST: 0,
    totalSGST: 0,
    totalTax: 0,
    totalAmount: 0,
    balanceDue: 0
  });

  const calculateTotals = (items, shippingCharge, shippingGST, gstType) => {
    const itemsCalc = items.map(item => {
      let igstAmount = 0;
      let cgstAmount = 0;
      let sgstAmount = 0;
      
      if (gstType === 'igst') {
        igstAmount = (item.rate * item.qty * item.igstPercent) / 100;
        cgstAmount = 0;
        sgstAmount = 0;
      } else {
        igstAmount = 0;
        cgstAmount = (item.rate * item.qty * item.cgstPercent) / 100;
        sgstAmount = (item.rate * item.qty * item.sgstPercent) / 100;
      }
      
      const totalTaxAmount = igstAmount + cgstAmount + sgstAmount;
      const amount = (item.rate * item.qty) + totalTaxAmount;
      
      return {
        ...item,
        igstAmount: parseFloat(igstAmount.toFixed(2)),
        cgstAmount: parseFloat(cgstAmount.toFixed(2)),
        sgstAmount: parseFloat(sgstAmount.toFixed(2)),
        amount: parseFloat(amount.toFixed(2))
      };
    });

    const taxableValue = itemsCalc.reduce((sum, item) => sum + (item.rate * item.qty), 0);
    const totalIGST = itemsCalc.reduce((sum, item) => sum + item.igstAmount, 0);
    const totalCGST = itemsCalc.reduce((sum, item) => sum + item.cgstAmount, 0);
    const totalSGST = itemsCalc.reduce((sum, item) => sum + item.sgstAmount, 0);
    const totalTax = totalIGST + totalCGST + totalSGST;
    
    let shippingIGSTAmount = 0;
    let shippingCGSTAmount = 0;
    let shippingSGSTAmount = 0;
    
    if (gstType === 'igst') {
      shippingIGSTAmount = (shippingCharge * shippingGST) / 100;
      shippingCGSTAmount = 0;
      shippingSGSTAmount = 0;
    } else {
      shippingIGSTAmount = 0;
      shippingCGSTAmount = (shippingCharge * shippingGST / 2) / 100;
      shippingSGSTAmount = (shippingCharge * shippingGST / 2) / 100;
    }
    
    const totalShippingTax = shippingIGSTAmount + shippingCGSTAmount + shippingSGSTAmount;
    const shippingTotal = parseFloat(shippingCharge) + parseFloat(totalShippingTax);
    const totalAmount = itemsCalc.reduce((sum, item) => sum + item.amount, 0) + shippingTotal;

    return {
      items: itemsCalc,
      taxableValue: parseFloat(taxableValue.toFixed(2)),
      totalIGST: parseFloat(totalIGST.toFixed(2)),
      totalCGST: parseFloat(totalCGST.toFixed(2)),
      totalSGST: parseFloat(totalSGST.toFixed(2)),
      totalTax: parseFloat(totalTax.toFixed(2)),
      shippingIGSTAmount: parseFloat(shippingIGSTAmount.toFixed(2)),
      shippingCGSTAmount: parseFloat(shippingCGSTAmount.toFixed(2)),
      shippingSGSTAmount: parseFloat(shippingSGSTAmount.toFixed(2)),
      shippingTotal: parseFloat(shippingTotal.toFixed(2)),
      totalAmount: parseFloat(totalAmount.toFixed(2)),
      balanceDue: parseFloat(totalAmount.toFixed(2))
    };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGSTTypeChange = (e) => {
    const { value } = e.target;
    
    const calculated = calculateTotals(
      invoiceData.items, 
      invoiceData.shippingCharge, 
      invoiceData.shippingGST,
      value
    );

    setInvoiceData(prev => ({
      ...prev,
      gstType: value,
      items: calculated.items,
      taxableValue: calculated.taxableValue,
      totalIGST: calculated.totalIGST,
      totalCGST: calculated.totalCGST,
      totalSGST: calculated.totalSGST,
      totalTax: calculated.totalTax,
      shippingIGSTAmount: calculated.shippingIGSTAmount,
      shippingCGSTAmount: calculated.shippingCGSTAmount,
      shippingSGSTAmount: calculated.shippingSGSTAmount,
      shippingTotal: calculated.shippingTotal,
      totalAmount: calculated.totalAmount,
      balanceDue: calculated.balanceDue
    }));
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...invoiceData.items];
    newItems[index][field] = value;
    
    // When tax percentage changes, update both IGST and CGST/SGST
    if (field === 'taxPercent') {
      newItems[index].igstPercent = value;
      newItems[index].cgstPercent = value / 2;
      newItems[index].sgstPercent = value / 2;
    }

    const calculated = calculateTotals(
      newItems, 
      invoiceData.shippingCharge, 
      invoiceData.shippingGST,
      invoiceData.gstType
    );

    setInvoiceData(prev => ({
      ...prev,
      items: calculated.items,
      taxableValue: calculated.taxableValue,
      totalIGST: calculated.totalIGST,
      totalCGST: calculated.totalCGST,
      totalSGST: calculated.totalSGST,
      totalTax: calculated.totalTax,
      totalAmount: calculated.totalAmount,
      balanceDue: calculated.balanceDue
    }));
  };

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    const newShippingCharge = name === 'shippingCharge' ? value : invoiceData.shippingCharge;
    let newShippingGST = invoiceData.shippingGST;
    
    if (name === 'shippingGST') {
      newShippingGST = value;
    }
  
    const calculated = calculateTotals(
      invoiceData.items, 
      newShippingCharge, 
      newShippingGST,
      invoiceData.gstType
    );
  
    setInvoiceData(prev => ({
      ...prev,
      [name]: value,
      shippingGST: newShippingGST,
      shippingIGST: newShippingGST,
      shippingCGST: newShippingGST / 2,
      shippingSGST: newShippingGST / 2,
      shippingIGSTAmount: calculated.shippingIGSTAmount,
      shippingCGSTAmount: calculated.shippingCGSTAmount,
      shippingSGSTAmount: calculated.shippingSGSTAmount,
      shippingTotal: calculated.shippingTotal,
      totalAmount: calculated.totalAmount,
      balanceDue: calculated.balanceDue
    }));
  };

  const addItem = () => {
    const taxPercent = invoiceData.items[0]?.taxPercent || 5;
    
    setInvoiceData(prev => ({
      ...prev,
      items: [
        ...prev.items,
        {
          description: '',
          hsnSac: '',
          qty: 1,
          rate: 0,
          taxPercent: taxPercent,
          igstPercent: taxPercent,
          igstAmount: 0,
          cgstPercent: taxPercent / 2,
          cgstAmount: 0,
          sgstPercent: taxPercent / 2,
          sgstAmount: 0,
          amount: 0
        }
      ]
    }));
  };

  const removeItem = (index) => {
    if (invoiceData.items.length > 1) {
      const newItems = invoiceData.items.filter((_, i) => i !== index);
      
      const calculated = calculateTotals(
        newItems, 
        invoiceData.shippingCharge, 
        invoiceData.shippingGST,
        invoiceData.gstType
      );

      setInvoiceData(prev => ({
        ...prev,
        items: calculated.items,
        taxableValue: calculated.taxableValue,
        totalIGST: calculated.totalIGST,
        totalCGST: calculated.totalCGST,
        totalSGST: calculated.totalSGST,
        totalTax: calculated.totalTax,
        totalAmount: calculated.totalAmount,
        balanceDue: calculated.balanceDue
      }));
    }
  };

  // Fixed numberToWords function to avoid stack overflow
  const numberToWords = (num) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    
    if (num === 0) return 'Zero';
    
    // Non-recursive implementation of sayNumber to prevent call stack overflow
    const sayNumber = (n) => {
      // Handle zero
      if (n === 0) return '';
      
      // Handle 1-19
      if (n < 20) return units[n];
      
      // Handle 20-99
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + units[n % 10] : '');
      
      // Handle 100-999
      if (n < 1000) return units[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + sayNumber(n % 100) : '');
      
      // Handle thousands (1,000 - 99,999)
      if (n < 100000) {
        const thousands = Math.floor(n / 1000);
        return sayNumber(thousands) + ' Thousand' + (n % 1000 !== 0 ? ' ' + sayNumber(n % 1000) : '');
      }
      
      // Handle lakhs (1,00,000 - 9,999,999)
      if (n < 10000000) {
        const lakhs = Math.floor(n / 100000);
        return sayNumber(lakhs) + ' Lakh' + (n % 100000 !== 0 ? ' ' + sayNumber(n % 100000) : '');
      }
      
      // Handle crores (1,00,00,000+)
      const crores = Math.floor(n / 10000000);
      return sayNumber(crores) + ' Crore' + (n % 10000000 !== 0 ? ' ' + sayNumber(n % 10000000) : '');
    };
    
    // Avoid potential NaN issues by using isNaN check
    if (isNaN(num)) return 'Zero';
    
    // Handle floating point number
    const rupees = Math.floor(num);
    const paise = Math.round((num - rupees) * 100);
    
    let result = sayNumber(rupees) + ' Rupees';
    if (paise > 0) {
      result += ' and ' + sayNumber(paise) + ' Paise';
    }
    
    return result;
  };

  const generateInvoice = () => {
    // Create a new jsPDF instance
    const doc = new jsPDF();
    
    // Set document properties
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('TAX INVOICE', doc.internal.pageSize.getWidth() / 2, 15, { align: 'center' });
    
    // Company details
    doc.setFontSize(14);
    doc.text(invoiceData.companyName, 15, 25);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(invoiceData.companyAddress, 15, 30);
    doc.text(`GSTIN: ${invoiceData.gstin}`, 15, 35);
    doc.text(`Email: ${invoiceData.companyEmail}`, 15, 40);
    doc.text(invoiceData.companyFullAddress, 15, 45);
    
    // Invoice details
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Invoice Details', 15, 60);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Invoice Date: ${invoiceData.invoiceDate}`, 15, 65);
    doc.text(`Invoice Number: ${invoiceData.invoiceNumber}`, 15, 70);
    
    // Bill To
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Bill To', 15, 80);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Name: ${invoiceData.billToName}`, 15, 85);
    doc.text(`Address: ${invoiceData.billToAddress}`, 15, 90);
    doc.text(`State: ${invoiceData.billToState}`, 15, 95);
    doc.text(`Pin Code: ${invoiceData.billToPinCode}`, 15, 100);
    doc.text(`GST Number: ${invoiceData.billToGST || 'N/A'}`, 15, 105);
    
    // Ship To
    // doc.setFontSize(12);
    // doc.setFont('helvetica', 'bold');
    // doc.text('Ship To', 120, 80);
    
    // doc.setFontSize(10);
    // doc.setFont('helvetica', 'normal');
    // doc.text(`Name: ${invoiceData.shipToName}`, 120, 85);
    // doc.text(`Address: ${invoiceData.shipToAddress}`, 120, 90);
    // doc.text(`City: ${invoiceData.shipToCity}`, 120, 95);
    // doc.text(`State: ${invoiceData.shipToState}`, 120, 100);
    // doc.text(`Pin Code: ${invoiceData.shipToPinCode}`, 120, 105);
    
    // Items Table - different headers based on GST type
    let itemsTableHeaders;
    
    if (invoiceData.gstType === 'igst') {
      itemsTableHeaders = [
        { header: '#', dataKey: 'index' },
        { header: 'Item & Description', dataKey: 'description' },
        { header: 'HSN/SAC', dataKey: 'hsnSac' },
        { header: 'Qty', dataKey: 'qty' },
        { header: 'Rate', dataKey: 'rate' },
        { header: 'IGST %', dataKey: 'igstPercent' },
        { header: 'IGST Amt', dataKey: 'igstAmount' },
        { header: 'Amount', dataKey: 'amount' }
      ];
    } else {
      itemsTableHeaders = [
        { header: '#', dataKey: 'index' },
        { header: 'Item & Description', dataKey: 'description' },
        { header: 'HSN/SAC', dataKey: 'hsnSac' },
        { header: 'Qty', dataKey: 'qty' },
        { header: 'Rate', dataKey: 'rate' },
        { header: 'CGST %', dataKey: 'cgstPercent' },
        { header: 'CGST Amt', dataKey: 'cgstAmount' },
        { header: 'SGST %', dataKey: 'sgstPercent' },
        { header: 'SGST Amt', dataKey: 'sgstAmount' },
        { header: 'Amount', dataKey: 'amount' }
      ];
    }
    
    const itemsTableData = invoiceData.items.map((item, index) => {
      if (invoiceData.gstType === 'igst') {
        return {
          index: index + 1,
          description: item.description,
          hsnSac: item.hsnSac,
          qty: item.qty,
          rate: (item.rate || 0).toFixed(2),
          igstPercent: `${item.igstPercent}%`,
          igstAmount: (item.igstAmount || 0).toFixed(2),
          amount: (item.amount || 0).toFixed(2)
        };
      } else {
        return {
          index: index + 1,
          description: item.description,
          hsnSac: item.hsnSac,
          qty: item.qty,
          rate: (item.rate || 0).toFixed(2),
          cgstPercent: `${item.cgstPercent}%`,
          cgstAmount: (item.cgstAmount || 0).toFixed(2),
          sgstPercent: `${item.sgstPercent}%`,
          sgstAmount: (item.sgstAmount || 0).toFixed(2),
          amount: (item.amount || 0).toFixed(2)
        };
      }
    });
    
    // Create the items table
    autoTable(doc, {
      startY: 115,
      head: [itemsTableHeaders.map(h => h.header)],
      body: itemsTableData.map(item => itemsTableHeaders.map(h => item[h.dataKey])),
      theme: 'grid',
      styles: { fontSize: 8 },
      headStyles: { fillColor: [200, 200, 200], textColor: [0, 0, 0], fontStyle: 'bold' }
    });
    
    // HSN/SAC Summary
    const hsnSummaryY = doc.lastAutoTable.finalY + 10;
    
    let hsnSummaryHeaders;
    
    if (invoiceData.gstType === 'igst') {
      hsnSummaryHeaders = [
        { header: 'HSN/SAC', dataKey: 'hsnSac' },
        { header: 'Taxable Value', dataKey: 'taxableValue' },
        { header: 'IGST %', dataKey: 'igstPercent' },
        { header: 'IGST Amt', dataKey: 'igstAmount' },
        { header: 'Total Tax Amount', dataKey: 'totalTax' }
      ];
    } else {
      hsnSummaryHeaders = [
        { header: 'HSN/SAC', dataKey: 'hsnSac' },
        { header: 'Taxable Value', dataKey: 'taxableValue' },
        { header: 'CGST %', dataKey: 'cgstPercent' },
        { header: 'CGST Amt', dataKey: 'cgstAmount' },
        { header: 'SGST %', dataKey: 'sgstPercent' },
        { header: 'SGST Amt', dataKey: 'sgstAmount' },
        { header: 'Total Tax Amount', dataKey: 'totalTax' }
      ];
    }
    
    // Group items by HSN/SAC code
    const hsnSummary = {};
    invoiceData.items.forEach(item => {
      const hsnCode = item.hsnSac || 'N/A';
      if (!hsnSummary[hsnCode]) {
        hsnSummary[hsnCode] = {
          hsnSac: hsnCode,
          taxableValue: 0,
          igstPercent: item.igstPercent,
          igstAmount: 0,
          cgstPercent: item.cgstPercent,
          cgstAmount: 0,
          sgstPercent: item.sgstPercent,
          sgstAmount: 0,
          totalTax: 0
        };
      }
      hsnSummary[hsnCode].taxableValue += item.rate * item.qty;
      hsnSummary[hsnCode].igstAmount += item.igstAmount || 0;
      hsnSummary[hsnCode].cgstAmount += item.cgstAmount || 0;
      hsnSummary[hsnCode].sgstAmount += item.sgstAmount || 0;
      hsnSummary[hsnCode].totalTax += (item.igstAmount || 0) + (item.cgstAmount || 0) + (item.sgstAmount || 0);
    });
    
    const hsnSummaryData = Object.values(hsnSummary).map(item => {
      if (invoiceData.gstType === 'igst') {
        return {
          hsnSac: item.hsnSac,
          taxableValue: (item.taxableValue || 0).toFixed(2),
          igstPercent: `${item.igstPercent}%`,
          igstAmount: (item.igstAmount || 0).toFixed(2),
          totalTax: (item.totalTax || 0).toFixed(2)
        };
      } else {
        return {
          hsnSac: item.hsnSac,
          taxableValue: (item.taxableValue || 0).toFixed(2),
          cgstPercent: `${item.cgstPercent}%`,
          cgstAmount: (item.cgstAmount || 0).toFixed(2),
          sgstPercent: `${item.sgstPercent}%`,
          sgstAmount: (item.sgstAmount || 0).toFixed(2),
          totalTax: (item.totalTax || 0).toFixed(2)
        };
      }
    });
    
    // Create the HSN/SAC summary table
    autoTable(doc, {
      startY: hsnSummaryY,
      head: [hsnSummaryHeaders.map(h => h.header)],
      body: hsnSummaryData.map(item => hsnSummaryHeaders.map(h => item[h.dataKey])),
      theme: 'grid',
      styles: { fontSize: 8 },
      headStyles: { fillColor: [200, 200, 200], textColor: [0, 0, 0], fontStyle: 'bold' }
    });
    
    // Shipping Charges
    const shippingY = doc.lastAutoTable.finalY + 10;
    
    let shippingHeaders;
    
    if (invoiceData.gstType === 'igst') {
      shippingHeaders = [
        { header: 'SAC', dataKey: 'sac' },
        { header: 'Return Shipping Charge', dataKey: 'charge' },
        { header: 'IGST Rate (%)', dataKey: 'igstRate' },
        { header: 'IGST Amount', dataKey: 'igstAmount' },
        { header: 'Total Shipping Charge', dataKey: 'total' }
      ];
    } else {
      shippingHeaders = [
        { header: 'SAC', dataKey: 'sac' },
        { header: 'Return Shipping Charge', dataKey: 'charge' },
        { header: 'CGST Rate (%)', dataKey: 'cgstRate' },
        { header: 'CGST Amount', dataKey: 'cgstAmount' },
        { header: 'SGST Rate (%)', dataKey: 'sgstRate' },
        { header: 'SGST Amount', dataKey: 'sgstAmount' },
        { header: 'Total Shipping Charge', dataKey: 'total' }
      ];
    }
    
    const shippingData = [{
      sac: '9965',
      charge: (invoiceData.shippingCharge || 0),
      igstRate: `${invoiceData.shippingIGST || 0}%`,
      igstAmount: (invoiceData.shippingIGSTAmount || 0).toFixed(2),
      cgstRate: `${invoiceData.shippingCGST || 0}%`,
      cgstAmount: (invoiceData.shippingCGSTAmount || 0).toFixed(2),
      sgstRate: `${invoiceData.shippingSGST || 0}%`,
      sgstAmount: (invoiceData.shippingSGSTAmount || 0).toFixed(2),
      total: (invoiceData.shippingTotal || 0).toFixed(2)
    }];
    
    // Create the shipping charges table
    autoTable(doc, {
      startY: shippingY,
      head: [shippingHeaders.map(h => h.header)],
      body: shippingData.map(item => shippingHeaders.map(h => item[h.dataKey])),
      theme: 'grid',
      styles: { fontSize: 8 },
      headStyles: { fillColor: [200, 200, 200], textColor: [0, 0, 0], fontStyle: 'bold' }
    });
    
    // Amount in words
    const amountY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(`Amount Chargeable (in words): ${numberToWords(invoiceData.totalAmount)} Only`, 15, amountY);
    
    // Totals
    doc.setFontSize(12);
    doc.text(`Total: ${(invoiceData.totalAmount || 0).toFixed(2)}`, 150, amountY + 10);
    doc.text(`Balance Due: ${(invoiceData.balanceDue || 0).toFixed(2)}`, 150, amountY + 20);
    
    // Footer
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('Thanks for your business.', 15, amountY + 30);
    
    doc.setFont('helvetica', 'italic');
    doc.text('Authorized Signature', 150, amountY + 40);
    
    // Save the PDF
    doc.save(`Invoice_${invoiceData.invoiceNumber || 'Draft'}.pdf`);
  };

  return (
    <div className="invoice-generator">
      <h1>Invoice Generator</h1>
      
      <div className="form-section">
        <h2>Company Details</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Company Name</label>
            <input 
              type="text" 
              name="companyName" 
              value={invoiceData.companyName} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input 
              type="text" 
              name="companyAddress" 
              value={invoiceData.companyAddress} 
              onChange={handleInputChange} 
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>GSTIN</label>
            <input 
              type="text" 
              name="gstin" 
              value={invoiceData.gstin} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input 
              type="email" 
              name="companyEmail" 
              value={invoiceData.companyEmail} 
              onChange={handleInputChange} 
            />
          </div>
        </div>
        <div className="form-group">
          <label>Full Address</label>
          <textarea 
            name="companyFullAddress" 
            value={invoiceData.companyFullAddress} 
            onChange={handleInputChange} 
          />
        </div>
      </div>
      
      <div className="form-section">
        <h2>Invoice Details</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Invoice Date</label>
            <input 
              type="text" 
              name="invoiceDate" 
              value={invoiceData.invoiceDate} 
              onChange={handleInputChange} 
              placeholder="e.g. 24 Mar 25" 
            />
          </div>
          <div className="form-group">
            <label>Invoice Number</label>
            <input 
              type="text" 
              name="invoiceNumber" 
              value={invoiceData.invoiceNumber} 
              onChange={handleInputChange} 
              placeholder="e.g. UC/2025-26/1072"/>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>GST Type</label>
            <select 
              name="gstType" 
              value={invoiceData.gstType} 
              onChange={handleGSTTypeChange}
            >
              <option value="igst">IGST (Interstate)</option>
              <option value="cgst_sgst">CGST & SGST (Intrastate)</option>
            </select>
          </div>
        </div>
      </div>
      
      <div className="form-section">
        <h2>Bill To</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Name</label>
            <input 
              type="text" 
              name="billToName" 
              value={invoiceData.billToName} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input 
              type="text" 
              name="billToAddress" 
              value={invoiceData.billToAddress} 
              onChange={handleInputChange} 
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>State</label>
            <input 
              type="text" 
              name="billToState" 
              value={invoiceData.billToState} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="form-group">
            <label>Pin Code</label>
            <input 
              type="text" 
              name="billToPinCode" 
              value={invoiceData.billToPinCode} 
              onChange={handleInputChange} 
            />
          </div>
        </div>
        <div className="form-group">
          <label>GST Number (optional)</label>
          <input 
            type="text" 
            name="billToGST" 
            value={invoiceData.billToGST} 
            onChange={handleInputChange} 
          />
        </div>
      </div>
      
      {/* <div className="form-section">
        <h2>Ship To</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Name</label>
            <input 
              type="text" 
              name="shipToName" 
              value={invoiceData.shipToName} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input 
              type="text" 
              name="shipToAddress" 
              value={invoiceData.shipToAddress} 
              onChange={handleInputChange} 
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>City</label>
            <input 
              type="text" 
              name="shipToCity" 
              value={invoiceData.shipToCity} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="form-group">
            <label>State</label>
            <input 
              type="text" 
              name="shipToState" 
              value={invoiceData.shipToState} 
              onChange={handleInputChange} 
            />
          </div>
        </div>
        <div className="form-group">
          <label>Pin Code</label>
          <input 
            type="text" 
            name="shipToPinCode" 
            value={invoiceData.shipToPinCode} 
            onChange={handleInputChange} 
          />
        </div>
      </div> */}
      
      <div className="form-section">
        <h2>Items</h2>
        {invoiceData.items.map((item, index) => (
          <div key={index} className="item-row">
            <div className="form-row">
              <div className="form-group">
                <label>Item Description</label>
                <input 
                  type="text" 
                  value={item.description} 
                  onChange={(e) => handleItemChange(index, 'description', e.target.value)} 
                />
              </div>
              <div className="form-group">
                <label>HSN/SAC</label>
                <input 
                  type="text" 
                  value={item.hsnSac} 
                  onChange={(e) => handleItemChange(index, 'hsnSac', e.target.value)} 
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Quantity</label>
                <input 
                  type="number" 
                  value={item.qty} 
                  onChange={(e) => handleItemChange(index, 'qty', parseInt(e.target.value) || 0)} 
                />
              </div>
              <div className="form-group">
                <label>Rate</label>
                <input 
                  type="number" 
                  step="0.01" 
                  value={item.rate} 
                  onChange={(e) => handleItemChange(index, 'rate', parseFloat(e.target.value) || 0)} 
                />
              </div>
              <div className="form-group">
                <label>Tax %</label>
                <input 
                  type="number" 
                  step="0.01" 
                  value={item.taxPercent} 
                  onChange={(e) => handleItemChange(index, 'taxPercent', parseFloat(e.target.value) || 0)} 
                />
              </div>
            </div>
            
            {invoiceData.gstType === 'igst' ? (
              <div className="form-row">
                <div className="form-group">
                  <label>IGST Amount</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    value={item.igstAmount.toFixed(2)} 
                    readOnly 
                  />
                </div>
                <div className="form-group">
                  <label>Amount</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    value={item.amount.toFixed(2)} 
                    readOnly 
                  />
                </div>
              </div>
            ) : (
              <div className="form-row">
                <div className="form-group">
                  <label>CGST Amount</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    value={item.cgstAmount.toFixed(2)} 
                    readOnly 
                  />
                </div>
                <div className="form-group">
                  <label>SGST Amount</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    value={item.sgstAmount.toFixed(2)} 
                    readOnly 
                  />
                </div>
                <div className="form-group">
                  <label>Amount</label>
                  <input 
                    type="number" 
                    step="0.01" 
                    value={item.amount.toFixed(2)} 
                    readOnly 
                  />
                </div>
              </div>
            )}
            
            {invoiceData.items.length > 1 && (
              <button 
                type="button" 
                className="remove-item" 
                onClick={() => removeItem(index)}
              >
                Remove Item
              </button>
            )}
            <hr />
          </div>
        ))}
        <button type="button" className="add-item" onClick={addItem}>
          Add Item
        </button>
      </div>
      
      <div className="form-section">
        <h2>Shipping</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Shipping Charge</label>
            <input 
              type="number" 
              step="0.01" 
              name="shippingCharge" 
              value={invoiceData.shippingCharge} 
              onChange={handleShippingChange} 
            />
          </div>
          <div className="form-group">
            <label>GST Rate %</label>
            <input 
              type="number" 
              step="0.01" 
              name="shippingGST" 
              value={invoiceData.shippingGST} 
              onChange={handleShippingChange} 
            />
          </div>
        </div>
        
        {invoiceData.gstType === 'igst' ? (
          <div className="form-row">
            <div className="form-group">
              <label>IGST Amount</label>
              <input 
                type="number" 
                step="0.01" 
                value={invoiceData.shippingIGSTAmount.toFixed(2)} 
                readOnly 
              />
            </div>
            <div className="form-group">
              <label>Total Shipping Charge</label>
              <input 
                type="number" 
                step="0.01" 
                value={invoiceData.shippingTotal.toFixed(2)} 
                readOnly 
              />
            </div>
          </div>
        ) : (
          <div className="form-row">
            <div className="form-group">
              <label>CGST Amount</label>
              <input 
                type="number" 
                step="0.01" 
                value={invoiceData.shippingCGSTAmount.toFixed(2)} 
                readOnly 
              />
            </div>
            <div className="form-group">
              <label>SGST Amount</label>
              <input 
                type="number" 
                step="0.01" 
                value={invoiceData.shippingSGSTAmount.toFixed(2)} 
                readOnly 
              />
            </div>
            <div className="form-group">
              <label>Total Shipping Charge</label>
              <input 
                type="number" 
                step="0.01" 
                value={invoiceData.shippingTotal.toFixed(2)} 
                readOnly 
              />
            </div>
          </div>
        )}
      </div>
      
      <div className="form-section">
        <h2>Summary</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Taxable Value</label>
            <input 
              type="number" 
              step="0.01" 
              value={invoiceData.taxableValue.toFixed(2)} 
              readOnly 
            />
          </div>
          
          {invoiceData.gstType === 'igst' ? (
            <div className="form-group">
              <label>Total IGST</label>
              <input 
                type="number" 
                step="0.01" 
                value={invoiceData.totalIGST.toFixed(2)} 
                readOnly 
              />
            </div>
          ) : (
            <>
              <div className="form-group">
                <label>Total CGST</label>
                <input 
                  type="number" 
                  step="0.01" 
                  value={invoiceData.totalCGST.toFixed(2)} 
                  readOnly 
                />
              </div>
              <div className="form-group">
                <label>Total SGST</label>
                <input 
                  type="number" 
                  step="0.01" 
                  value={invoiceData.totalSGST.toFixed(2)} 
                  readOnly 
                />
              </div>
            </>
          )}
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Total Tax</label>
            <input 
              type="number" 
              step="0.01" 
              value={invoiceData.totalTax.toFixed(2)} 
              readOnly 
            />
          </div>
          <div className="form-group">
            <label>Total Amount</label>
            <input 
              type="number" 
              step="0.01" 
              value={invoiceData.totalAmount.toFixed(2)} 
              readOnly 
            />
          </div>
          <div className="form-group">
            <label>Balance Due</label>
            <input 
              type="number" 
              step="0.01" 
              value={invoiceData.balanceDue.toFixed(2)} 
              readOnly 
            />
          </div>
        </div>
        <div className="form-group">
          <label>Amount in Words</label>
          <input 
            type="text" 
            value={`${numberToWords(invoiceData.totalAmount)} Only`} 
            readOnly 
          />
        </div>
      </div>
      
      <button type="button" className="generate-invoice" onClick={generateInvoice}>
        Generate Invoice
      </button>
    </div>
  );
};

export default InvoiceGenerator;